module.exports = __webpack_public_path__ + "static/media/3.dde14408.png";